import { render } from "./coursewareInfo.vue?vue&type=template&id=7f3dac8e&scoped=true"
import script from "./coursewareInfo.vue?vue&type=script&lang=js"
export * from "./coursewareInfo.vue?vue&type=script&lang=js"

import "./coursewareInfo.vue?vue&type=style&index=0&id=7f3dac8e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3dac8e"]])

export default __exports__